export class ReturnRecognition {
  solicitud: number;
  consecutivo: number;
  materia: number;
}
